<template>
  <!--产品详情 -->
  <transition name="el-fade-in-linear">
    <div class="divliebiao" v-show="dialogFormVisible" :style="contentStyle">
      <div class="divliebiaoright">
        <div class="listhead">
          <div class="listtitle">{{$route.path === '/remoteSenseData' ? '数据详情' : '信息详情'}}</div>
          <div class="closed"><i class="el-icon-close" @click="closed"></i></div>
        </div>
        <div class="listbody">
          <div class="listrow">
            <span>名称</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.productName : dynamicTags.product_file_name}}</span>
          </div>
          <!-- <div class="listrow">
            <span>id</span>
            <span class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.imageId : dynamicTags.product_id}}</span>
          </div> -->
          <!-- <div class="listrow">
            <span>price</span>
            <span class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.productPrice : dynamicTags.product_price}}</span>
          </div> -->
          <div class="listrow">
            <span>类型</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.productDescription : dynamicTags.product_description}}</span>
          </div>
          <div class="listrow">
            <span>日期</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.productDate : dynamicTags.product_date}}</span>
          </div>
          <div class="listrow">
            <span>纬度</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.centerLat : dynamicTags.center_lat}}</span>
          </div>
          <div class="listrow">
            <span>经度</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.centerLong : dynamicTags.center_long}}</span>
          </div>
          <div class="listrow">
            <span>北</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.upperLeftLat : dynamicTags.upper_left_lat}}</span>
          </div>
          <div class="listrow">
            <span>西</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.upperLeftLong : dynamicTags.upper_left_long}}</span>
          </div>
          <div class="listrow">
            <span>南</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.lowerRightLat : dynamicTags.lower_right_lat}}</span>
          </div>
          <div class="listrow">
            <span>东</span>
            <span
              class="listcontet">{{$route.path === '/remoteSenseData' ? dynamicTags.lowerRightLong : dynamicTags.lower_right_long}}</span>
          </div>
          <div class="listrow" v-if="$route.path !== '/remoteSenseData'">
            <span>影响分辨率</span>
            <span class="listcontet">{{dynamicTags.cndr}}</span>
          </div>
          <div class="listrow" v-if="$route.path !== '/remoteSenseData'">
            <span>投影</span>
            <span
              class="listcontet">{{"ESPG:"+$route.path === '/remoteSenseData' ? dynamicTags.mapProjection : dynamicTags.map_projection}}</span>
          </div>
          <div class="listrow" v-if="$route.path === '/remoteSenseData' && dynamicTags.quickView !== '0'">
            <span>快视图</span>
            <span class="listcontet">
              <el-image v-if="dynamicTags.quickViewUrl !== undefined" :src="this.$root.URL+'/'+dynamicTags.quickView"
                fit="contain" style="height: 150px;">
              </el-image>
            </span>
          </div>

        </div>
      </div>
    </div>

  </transition>
</template>

<script>
export default {
  name: 'HeadProductContentDialog',
  props: ['msgFather', 'prodata'],
  data () {
    return {
      dialogFormVisible: false,
      contentStyle: 'margin-left:5px',
      dynamicTags: {}
    }
  },
  created () {
    this.dynamicTags = this.prodata
    console.log(this.dynamicTags)
    this.dialogFormVisible = this.msgFather
    if (this.$route.path === '/remoteSenseData') {
      this.contentStyle = 'margin-left:370px'
    } else {
      this.contentStyle = 'margin-left:5px'
    }
  },
  methods: {
    sendMsgToParent: function () {
      this.$emit('getproductcontentdialogFormVisible', this.dialogFormVisible)
    },
    closed: function () {
      this.dialogFormVisible = false
    }
  },
  watch: {
    $route (val) {
      if (val.path === '/remoteSenseData') {
        this.contentStyle = 'margin-left:370px'
      } else {
        this.contentStyle = 'margin-left:5px'
      }
    },
    msgFather: function (curVal) {
      console.log(curVal)
      this.dialogFormVisible = curVal
    },
    dialogFormVisible: function () {
      this.sendMsgToParent()
    },
    prodata: function (data) {
      this.dynamicTags = data
    }
  }
}
</script >
<style >
.listcontet {
  text-align: left;
  width: 60%;
  padding-right: 15px;
  word-wrap: break-word;
  line-height: 1.5;
}
.listrow {
  display: flex;
  justify-content: space-between;
  padding-left: 15px;
  margin-top: 10px;
  font-size: 14px;
  color: rgb(28, 203, 150);
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background-color: #fff;
}
::-webkit-scrollbar-thumb {
  background-color: #18bc9c;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #18bc9c;
}
::-webkit-scrollbar-thumb:active {
  background-color: #18bc9c;
}
.gundong {
  overflow-y: auto;
  overflow-x: hidden;
  height: 94%;
}
.listcheckall {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 48px;
  padding-top: 10px;
}
.listcheckbody {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-left: 20px;
  padding-right: 12px;
}
.listcheckbody i {
  margin-top: 0px;
  color: #ccc;
}
.listbody {
  height: 91%;
}
.listhead {
  display: flex;
  background-color: #191b2e;
  height: 20px;
  padding: 10px;
  justify-content: space-between;
  color: #fff;
  font-size: 14px;
}
.divliebiao {
  background-color: #191b2e;
  width: 300px;
  height: 100%;
  margin-left: 53px;
}
.divliebiaoright {
  width: 300px;
  height: 100%;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/LeftMenu/HeadProductContentDialog.vue